import React, { useState } from 'react';
import { Quote } from 'lucide-react';
import { buildPublicFileUrl } from '../../utils/fileUrl';

export default function TestimonialCard({ quote, author, role, image, imageUrl }) {
  const [failed, setFailed] = useState(false);
  const rawImage = imageUrl || image;
  const initials = (author || 'Guest').split(/\s+/).slice(0, 2).map(word => word[0]).join('').toUpperCase();
  return <figure className="rounded-2xl border border-gray-200 bg-white p-5 sm:p-6 flex flex-col text-left h-full">
    <Quote className="h-7 w-7 text-brand-orange-500 mb-4" aria-hidden="true" />
    <blockquote className="text-sm sm:text-base text-gray-700 leading-relaxed flex-1 whitespace-pre-wrap break-words">{quote}</blockquote>
    <figcaption className="mt-5 pt-4 border-t border-gray-100 flex items-center gap-3">
      <div className="h-10 w-10 shrink-0 rounded-full bg-brand-orange-50 text-brand-orange-500 flex items-center justify-center overflow-hidden text-sm font-bold">{rawImage && !failed ? <img src={buildPublicFileUrl(rawImage)} alt="" loading="lazy" onError={() => setFailed(true)} className="h-full w-full object-cover" /> : initials}</div>
      <div className="min-w-0"><p className="text-sm font-semibold text-brand-black break-words">{author || 'Go Rides customer'}</p>{role && <p className="text-xs text-gray-500 mt-0.5 break-words">{role}</p>}</div>
    </figcaption>
  </figure>;
}
